const language = {
        'pt':
        {
                config: ' Configurações',
                entidade_interna: 'Entidade Interna',
                entidade_externa: 'Entidade Externa',
                accommodation: 'Alojamentos',
                accommodation_list: 'Lista de alojamentos',
                accommodation_new: 'Novo alojamentos',
                activities: 'Atividades',
                activity_list: 'Lista de atividades',
                activity_new: 'Inserir atividade',
                animations: 'Animações',
                animation_list: 'Lista de animações',
                animation_new: 'Inserir animação',
                articles: 'Notícias',
                articles_list: 'Lista de artigos',
                article_new: 'Novo artigo',
                attributes: 'Atributos',
                attributes_list: 'Lista de atributos',
                attribute_new: 'Novo atributo',
                attribute_values: 'Valores',
                attribute_values_list: 'Lista de Valores',
                attribute_value_new: 'Novo valor',
                banners: 'Banners',
                banners_list: 'Lista de banners',
                banner_new: 'Novo banner',
                brands: 'Marcas',
                brands_list: 'Lista de marcas',
                brand_new: 'Nova marca',
                agenda: 'Agenda',
                evento: 'Evento',
                event_type: 'Tipo de Evento',
                forms: 'Formulários',
                forms_type: 'Tipo de Formulário',
                intranet__quality_epi_create: 'Equipamento de Proteção Individual',
                calendar: 'Calendário',
                carrier_list: 'Lista de Transportadoras',
                categories: 'Categorias',
                categories_list: 'Lista de categorias',
                category_new: 'Inserir categoria',
                choose_option: 'Escolher',
                content: 'Conteúdo',
                content_list: 'Lista de conteúdos',
                content_new: 'Novo conteúdo',
                contest: 'Concurso',
                contest_list: 'Lista de inscritos',
                contest_new: 'Novo inscrito',
                country_list: 'Lista de países',
                estancia: 'Estância',
                estancia_aulas: 'Marcação de Aulas',
                estancia_aulas_list: 'Lista de aulas',
                estancia_aulas_new: 'Inserir aula',
                estancia_aulas_add: 'Adicionar aula',
                estancia_aulas_info: 'Aulas',
                estancia_aulas_info_list: 'Lista de aulas',
                estancia_aulas_info_new: 'Inserir aula',
                estancia_aulas_info_add: 'Adicionar aula',
                estancia_aulas_cliente: 'Agendar Aula',
                estancia_config: 'Gestão de pistas',
                estancia_meios: 'Meios Mecânicos',
                estancia_meios_list: 'Lita de meios mecânicos',
                estancia_meio_new: 'Inserir meio',
                estancia_meio_add: 'Adicionar meio',
                estancia_pistas: 'Pistas',
                estancia_pistas_list: 'Lista pistas',
                estancia_pista_new: 'Inserir pista',
                estancia_pista_add: 'Adicionar pista',
                estancia_forfaits: 'Forfaits',
                estancia_forfaits_list: 'Lista forfaits',
                estancia_forfait_new: 'Inserir forfait',
                estancia_forfait_add: 'Adicionar forfait',
                estancia_equipamentos: 'Equipamentos',
                estancia_equipamentos_list: 'Lista equipamentos',
                estancia_equipamento_new: 'Inserir equipamento',
                estancia_equipamento_add: 'Adicionar equipamento',
                estancia_vouchers: 'Vouchers',
                estancia_vouchers_list: 'Lista vouchers',
                estancia_voucher_new: 'Inserir voucher',
                estancia_voucher_add: 'Adicionar voucher',
                estancia_packs: 'Packs',
                estancia_packs_list: 'Lista progrmas',
                estancia_pack_new: 'Inserir pack',
                estancia_pack_add: 'Adicionar pack',
                estancia_activities: 'Atividades',
                estancia_activities_list: 'Lista atividades',
                estancia_activities_new: 'Inserir atividade',
                estancia_activities_add: 'Adicionar atividade',
                estancia_zonas: 'Zonas',
                estancia_zonas_list: 'Lista zonas',
                estancia_zona_new: 'Inserir zona',
                estancia_zona_add: 'Adicionar zona',
                estancia_instrutores: 'Instrutores',
                estancia_colaboradores: 'Colaboradores',
                estancia_parametros: 'Parâmetros',
                estancia_produtos: 'Produtos',
                goldenrock: 'Golden Rock',
                goldenrock_espaco: 'Espaço',
                goldenrock_category: 'Categoria',
                goldenrock_servico: 'Serviço',
                goldenrock_terapeuta: 'Terapeuta',
                goldenrock_professor: 'Professor',
                goldenrock_horario: 'Horário',
                goldenrock_wellness: 'Wellness',
                goldenrock_wellness_stock: 'Stock Wellness',
                goldenrock_spa: 'SPA',
                goldenrock_spa_stock: 'Stock SPA',
                goldenrock_piscinas: 'Piscinas',
                goldenrock_piscinas_stock: 'Stock Piscinas',
                goldenrock_ginasio: 'Ginásio',
                goldenrock_ginasio_stock: 'Stock Ginásio',
                goldenrock_personaltrainer: 'Personal Trainer',
                features: 'Características',
                features_list: 'Lista de características',
                feature_new: 'Nova característica',
                feature_values: 'Valores',
                feature_values_list: 'Lista de Valores',
                feature_value_new: 'Novo valor',
                galleries: 'Galerias',
                galleries_list: 'Lista de galerias',
                gallery_new: 'Inserir galeria',
                intranet: 'Intranet',
                intranet_department: 'Departamento',
                intranet_groups: 'Grupos',
                intranet_quality: 'Qualidade',
                intranet_quality_document: 'Gestão Documental',
                intranet_quality_document_obsolete: 'Documentos Obsoletos',
                intranet_quality_document_deleted: 'Documentos Eliminados',
                intranet_quality_document_type: 'Tipo de Documento',
                intranet_quality_retention_type: 'Tempo de Retenção',
                intranet_quality_storage_type: 'Tipo de Armazenamento',
                intranet_quality_occurrence: 'Gestão de Ocorrência',
                intranet_quality_occurrence_type: 'Tipo de Ocorrência',
                intranet_quality_occurrence_origin: 'Origem da Ocorrência',
                intranet_quality_occurrence_state: 'Estado da Ocorrência',
                intranet_quality_strategy: 'Planeamento Estratégico',
                intranet_quality_strategybetsrisks: 'Gestão de Apostas e Riscos',
                intranet_quality_monitoring_indicators: 'Gestão de Indicadores',
                intranet_quality_formation: 'Gestão de Formações',
                intranet_quality_formation_classification_type: 'Tipos de Avaliação de Formações',
                intranet_quality_formation_state_type: 'Tipos de Estados de Formações',
                intranet_quality_supplier_evaluation: 'Avaliação de Fornecedores',
                intranet_quality_supplier_evaluation_criterion: 'Critérios de Avaliação',
                intranet_quality_supplier_type: 'Avaliação de Fornecedores',
                intranet_quality_supply_quality_type: 'Avaliação de Fornecimento',
                intranet_quality_supply_type: 'Tipo de Fornecimento',
                intranet_crm_opportunity: 'Oportunidades',
                intranet_crm_stage_type: 'Tipos de Estado',
                intranet_crm_comtype: 'Tipos de Comunicação',
                intranet_quality_epi_create: 'Equi. de Proteção Individual',
                intranet_quality_epi_stage_type: 'Tipo de EPI',
                intranet_maintenance: 'Manutenção',
                intranet_maintenance_active: 'Ativo',
                intranet_maintenance_repair: 'Reparação',
                intranet_maintenance_orders: 'Ordens de Manutenção',
                intranet_maintenance_active_type: 'Tipo de Ativo',
                intranet_maintenance_active_state: 'Tipo de Estado',
                intranet_maintenance_repair_type: 'Tipo de Reparação',
                intranet_maintenance_energy_type: 'Tipo de Energia',
                intranet_maintenance_planeamento: 'Planeamento',
                intranet_maintenance_periodicity: 'Periodicidade',
                intranet_maintenance_priority: 'Prioridade',
                intranet_maintenance_intervention: 'Registo de Intervenção',
                intranet_maintenance_cost: 'Custo de Manutenção',
                intranet_maintenance_energy: 'Gestão de Energia',
                intranet_config: 'Config',
                menus: 'Menus',
                menus_list: 'Lista de menus',
                menu_new: 'Inserir menu',
                my_data: 'Os meus dados',
                painel_principal: 'Painel Principal',
                normas_submissao: 'Normas de submissão',
                evento: 'Evento',
                lista_eventos: 'Lista de Eventos',
                inserir_evento: 'Inserir Evento',
                events: 'Eventos',
                event_list: 'Lista de Eventos',
                event_new: 'Inserir Evento',
                call_for_papers: 'Call for papers',
                lista_cfp: 'Lista de Cfp',
                inserir_cfp: 'Inserir Cfp',
                perfis: 'Perfis',
                lista_perfis_app: 'Perfis de utilizadores',
                lista_perfis_empresa: 'Tipos de entidade',
                lista_entidade_funcoes: 'Funções',
                lista_entidade_setores: 'Setores',
                lista_entidade_dimensoes: 'Dimensões',
                lista_entidade_relacoes: 'Relações',
                inserir_perfil: 'Novo perfil',
                novo: 'Novo',
                autor: 'Autor',
                lista_autores: 'Lista de autores',
                revisor: 'Revisor',
                lista_revisores: 'Lista de revisores',
                editor: 'Editor',
                lista_editores: 'Lista de editores',
                artigo: 'Artigo',
                novo_artigo: 'Adicionar artigo',
                lista_artigos: 'Lista de artigos',
                conteudo_site: 'Conteúdo site',
                conteudo: 'Conteúdo',
                corporate: 'Corporate',
                novo_conteudo: 'Novo conteúdo',
                difusao_cientifica: 'Difusão',
                revista: 'Revista',
                conferencia: 'Conferência',
                nova_difusao: 'Nova difusão',
                termos: 'Termos',
                termos_condicoes: 'Termos e condições',
                separador_intranet: 'INTRANET',
                separador_outros: 'OUTROS',
                separador_quality: 'QUALIDADE',
                separador_maintenance: 'MANUTENÇÃO E ENERGIA',
                store: 'Loja Online',
                store_products: 'Produtos',
                store_products_list: 'Lista de Produtos',
                store_product_new: 'Inserir Produtos',
                store_product_add: 'Adicionar Produtos',
                press: 'Imprensa',
                press_list: 'Lista de imprensa',
                press_new: 'Novo artigo',
                projects: 'Projectos',
                project_areas: 'Áreas temáticas',
                project_areas_list: 'Lista de áreas',
                project_area_new: 'Inserir área',
                project_area_add: 'Adicionar áreas',
                project_domains: 'Domínios',
                project_domains_list: 'Lista de Domínios',
                project_domain_new: 'Inserir domínio',
                project_domain_add: 'Adicionar domínio',
                project_funds: 'Fundos',
                project_funds_list: 'Lista de Fundos',
                project_fund_new: 'Inserir fundo',
                project_fund_add: 'Adicionar fundo',
                project_parameters: 'Parâmetros',
                project_programs: 'Packs',
                project_programs_list: 'Lista de packs',
                project_program_new: 'Inserir pack',
                project_program_add: 'Adicionar pack',
                project_scopes: 'Âmbito Territorial',
                project_scopes_list: 'Lista de âmbitos',
                project_scope_new: 'Inserir âmbito',
                project_scope_add: 'Adicionar âmbito',
                politica_privacidade: 'Política de privacidade',
                purchase_order: 'Encomendas',
                restaurant: 'Restaurantes',
                restaurant_list: 'Lista de restaurantes',
                restaurant_new: 'Novo restaurante',
                routes: 'Roteiros e Rotas',
                routes_list: 'Lista de roteiros',
                routes_new: 'Novo roteiro',
                store_parameters: 'Parâmetros',
                store_shipping: 'Envio',
                taxe_list: 'Lista de taxas',
                testemonies: 'Testemunhos',
                testemonies_list: 'Lista de testemunhos',
                testemony_new: 'Inserir testemunho',
                webuser: 'Utilizadores',
                webuser_list: 'Lista de utilizadores',
                webuser_new: 'Inserir utilizador',
                client: 'Cliente',
                company: 'Empresa',
                client_list: 'Lista de clientes',
                client_new: 'Inserir cliente',
                empresa: 'Empresa',
                empresa_list: 'Lista de Empresa',
                empresa_new: 'Inserir Empresa',
                empresa01: 'Empresa01',
                empresa01_list: 'Lista de Empresa01',
                empresa01_new: 'Inserir Empresa01',
                //Beatriz
                empresa02: 'Empresa02',
                empresa02_list: 'Lista de Empresa02',
                empresa02_new: 'Inserir Empresa02',

                entidade02: 'Entidade02',
                entidade02_list: 'Lista de Entidade02',
                entidade02_new: 'Inserir Entidade02',


                tarefa: 'Tarefas',
                tarefa_list: 'Lista de Tarefa',
                tarefa_new: 'Inserir Tarefa',

                projetos: 'Projetos',
                projetos_list: 'Lista de Projetos',
                projetos_new: 'Inserir projeto',

                suporte: 'Suporte',
                suporte_list: 'Lista de Tickets',
                suporte_new: 'Inserir Ticket',

                entidade: 'Entidades',
                entidade_list: 'Lista de entidades',
                entidade_new: 'Inserir entidade',
                zone_list: 'Lista de zonas',

                colaborador: 'Colaboradores',
                colaborador_list: 'Lista de Colaborador',
                colaborador_new: 'Inserir Colaborador',
                externa_entidade_list: 'Lista de Entidades Externas',

                license: 'Licença',
                separador_crm: 'CRM',
        },

        'en': {
                config: ' Config',
                entidade_interna: 'Internal Entity',
                externa_entidade_list: 'External entity list',
                entidade_externa: 'External Entity',
                accommodation: 'Accommodations',
                accommodation_list: 'Accommodation List',
                accommodation_new: 'New Accommodation',
                activities: 'Activities',
                activity_list: 'Activity List',
                activity_new: 'Insert Activity',
                animations: 'Animations',
                animation_list: 'Animation List',
                animation_new: 'Insert Animation',
                articles: 'News',
                articles_list: 'News List',
                article_new: 'New Article',
                attributes: 'Attributes',
                attributes_list: 'Attributes List',
                attribute_new: 'New Attribute',
                attribute_values: 'Values',
                attribute_values_list: 'Values List',
                attribute_value_new: 'New Value',
                banners: 'Banners',
                banners_list: 'Banner List',
                banner_new: 'New Banner',
                brands: 'Brands',
                brands_list: 'Brand List',
                brand_new: 'New Brand',
                agenda: 'Agenda',
                evento: 'Event',
                event_type: 'Event Type',
                intranet__quality_epi_create: 'Ind. Protective Equipment',
                forms: 'Forms',
                forms_type: 'Form Type',
                calendar: 'Calendar',
                carrier_list: 'Carrier List',
                categories: 'Categories',
                categories_list: 'Category List',
                category_new: 'Insert Category',
                choose_option: 'Choose',
                content: 'Content',
                content_list: 'Content List',
                content_new: 'New Content',
                contest: 'Contest',
                contest_list: 'Contestant List',
                contest_new: 'New Contestant',
                country_list: 'Country List',
                estancia: 'Resort',
                estancia_aulas: 'Lesson Booking',
                estancia_aulas_list: 'Lesson List',
                estancia_aulas_new: 'Insert Lesson',
                estancia_aulas_add: 'Add Lesson',
                estancia_aulas_info: 'Lessons',
                estancia_aulas_info_list: 'Lesson List',
                estancia_aulas_info_new: 'Insert Lesson',
                estancia_aulas_info_add: 'Add Lesson',
                estancia_aulas_cliente: 'Schedule Lesson',
                estancia_config: 'Slope Management',
                estancia_meios: 'Mechanical Lifts',
                estancia_meios_list: 'Mechanical Lift List',
                estancia_meio_new: 'Insert Lift',
                estancia_meio_add: 'Add Lift',
                estancia_pistas: 'Slopes',
                estancia_pistas_list: 'Slope List',
                estancia_pista_new: 'Insert Slope',
                estancia_pista_add: 'Add Slope',
                estancia_forfaits: 'Ski Passes',
                estancia_forfaits_list: 'Ski Pass List',
                estancia_forfait_new: 'Insert Ski Pass',
                estancia_forfait_add: 'Add Ski Pass',
                estancia_equipamentos: 'Equipment',
                estancia_equipamentos_list: 'Equipment List',
                estancia_equipamento_new: 'Insert Equipment',
                estancia_equipamento_add: 'Add Equipment',
                estancia_vouchers: 'Vouchers',
                estancia_vouchers_list: 'Voucher List',
                estancia_voucher_new: 'Insert Voucher',
                estancia_voucher_add: 'Add Voucher',
                estancia_packs: 'Packs',
                estancia_packs_list: 'Program List',
                estancia_pack_new: 'Insert Pack',
                estancia_pack_add: 'Add Pack',
                estancia_activities: 'Activities',
                estancia_activities_list: 'Activity List',
                estancia_activities_new: 'Insert Activity',
                estancia_activities_add: 'Add Activity',
                estancia_zonas: 'Zones',
                estancia_zonas_list: 'Zone List',
                estancia_zona_new: 'Insert Zone',
                estancia_zona_add: 'Add Zone',
                estancia_instrutores: 'Instructors',
                estancia_colaboradores: 'Staff',
                estancia_parametros: 'Parameters',
                estancia_produtos: 'Products',
                goldenrock: 'Golden Rock',
                goldenrock_espaco: 'Space',
                goldenrock_category: 'Category',
                goldenrock_servico: 'Service',
                goldenrock_terapeuta: 'Therapist',
                goldenrock_professor: 'Teacher',
                goldenrock_horario: 'Schedule',
                goldenrock_wellness: 'Wellness',
                goldenrock_wellness_stock: 'Wellness Stock',
                goldenrock_spa: 'SPA',
                goldenrock_spa_stock: 'SPA Stock',
                goldenrock_piscinas: 'Pools',
                goldenrock_piscinas_stock: 'Pool Stock',
                goldenrock_ginasio: 'Gym',
                goldenrock_ginasio_stock: 'Gym Stock',
                goldenrock_personaltrainer: 'Personal Trainer',
                features: 'Features',
                features_list: 'Feature List',
                feature_new: 'New Feature',
                feature_values: 'Values',
                feature_values_list: 'Value List',
                feature_value_new: 'New Value',
                galleries: 'Galleries',
                galleries_list: 'Gallery List',
                gallery_new: 'Insert Gallery',
                intranet: 'Intranet',
                intranet_department: 'Department',
                intranet_groups: 'Grupos',
                intranet_quality: 'Qualidade',
                intranet_quality_document: 'Gestão Documental',
                intranet_quality_document_obsolete: 'Documentos Obsoletos',
                intranet_quality_document_deleted: 'Documentos Eliminados',
                intranet_quality_document_type: 'Tipo de Documento',
                intranet_quality_retention_type: 'Tempo de Retenção',
                intranet_quality_storage_type: 'Tipo de Armazenamento',
                intranet_quality_occurrence: 'Gestão de Ocorrência',
                intranet_quality_occurrence_type: 'Tipo de Ocorrência',
                intranet_quality_occurrence_origin: 'Origem da Ocorrência',
                intranet_quality_occurrence_state: 'Estado da Ocorrência',
                intranet_quality_strategy: 'Planeamento Estratégico',
                intranet_quality_strategybetsrisks: 'Gestão de Apostas e Riscos',
                intranet_quality_monitoring_indicators: 'Gestão de Indicadores',
                intranet_quality_formation: 'Gestão de Formações',
                intranet_quality_formation_classification_type: 'Tipos de Avaliação de Formações',
                intranet_quality_formation_state_type: 'Tipos de Estados de Formações',
                intranet_quality_supplier_evaluation: 'Avaliação de Fornecedores',
                intranet_quality_supplier_evaluation_criterion: 'Critérios de Avaliação',
                intranet_quality_supplier_type: 'Avaliação de Fornecedores',
                intranet_quality_supply_quality_type: 'Avaliação de Fornecimento',
                intranet_quality_supply_type: 'Tipo de Fornecimento',
                separador_crm: 'CRM',
                intranet_crm_opportunity: 'Oportunidades',
                intranet_crm_stage_type: 'CRM Stage Type',
                intranet_crm_comtype: 'CRM Communication Type',    
                intranet_quality_epi_create: 'Ind. Protective Equipment', 
                intranet_quality_epi_stage_type: 'EPI Type',           
                intranet_maintenance: 'Manutenção',
                intranet_maintenance_active: 'Ativo',
                intranet_maintenance_repair: 'Reparação',
                intranet_maintenance_active_type: 'Tipo de Ativo',
                intranet_maintenance_active_state: 'Tipo de Estado',
                intranet_maintenance_repair_type: 'Tipo de Reparação',
                intranet_maintenance_energy_type: 'Tipo de Energia',
                intranet_maintenance_planeamento: 'Planeamento',
                intranet_maintenance_periodicity: 'Periodicidade',
                intranet_maintenance_priority: 'Priority',
                intranet_maintenance_intervention: 'Intervention Record',
                intranet_maintenance_cost: 'Maintenance Cost',
                intranet_maintenance_energy: 'Energy Management',
                intranet_config: 'Config',
                menus: 'Menus',
                menus_list: 'Menu List',
                menu_new: 'Insert Menu',
                my_data: 'My Data',
                painel_principal: 'Main Panel',
                normas_submissao: 'Submission Rules',
                evento: 'Event',
                event_type: 'Event Type',
                lista_eventos: 'Event List',
                inserir_evento: 'Insert Event',
                events: 'Events',
                event_list: 'Event List',
                event_new: 'Insert Event',
                call_for_papers: 'Call for Papers',
                lista_cfp: 'CFP List',
                inserir_cfp: 'Insert CFP',
                perfis: 'Profiles',
                lista_perfis_app: 'Users profiles',
                lista_perfis_empresa: 'Entity types',
                lista_entidade_funcoes: 'Funções',
                lista_entidade_setores: 'Setores',
                lista_entidade_dimensoes: 'Dimensões',
                lista_entidade_relacoes: 'Relações',
                inserir_perfil: 'New Profile',
                novo: 'New',
                autor: 'Author',
                lista_autores: 'Author List',
                revisor: 'Reviewer',
                lista_revisores: 'Reviewer List',
                editor: 'Editor',
                lista_editores: 'Editor List',
                artigo: 'Article',
                novo_artigo: 'Add Article',
                lista_artigos: 'Article List',
                conteudo_site: 'Site Content',
                conteudo: 'Content',
                corporate: 'Corporate',
                novo_conteudo: 'New Content',
                difusao_cientifica: 'Dissemination',
                revista: 'Magazine',
                conferencia: 'Conference',
                nova_difusao: 'New Dissemination',
                termos: 'Terms',
                termos_condicoes: 'Terms and Conditions',
                separador_intranet: 'INTRANET',
                separador_outros: 'OUTROS',
                separador_quality: 'QUALIDADE',
                separador_maintenance: 'MANUTENÇÃO E ENERGIA',
                store: 'Online Store',
                store_products: 'Products',
                store_products_list: 'Product List',
                store_product_new: 'Insert Product',
                store_product_add: 'Add Product',
                press: 'Press',
                press_list: 'Press List',
                press_new: 'New Article',
                projects: 'Projects',
                project_areas: 'Thematic Areas',
                project_areas_list: 'Thematic Area List',
                project_area_new: 'Insert Area',
                project_area_add: 'Add Area',
                project_domains: 'Domains',
                project_domains_list: 'Domain List',
                project_domain_new: 'Insert Domain',
                project_domain_add: 'Add Domain',
                project_funds: 'Funds',
                project_funds_list: 'Fund List',
                project_fund_new: 'Insert Fund',
                project_fund_add: 'Add Fund',
                project_parameters: 'Parameters',
                project_programs: 'Packs',
                project_programs_list: 'Pack List',
                project_program_new: 'Insert Pack',
                project_program_add: 'Add Pack',
                project_scopes: 'Territorial Scope',
                project_scopes_list: 'Scope List',
                project_scope_new: 'Insert Scope',
                project_scope_add: 'Add Scope',
                politica_privacidade: 'Privacy Policy',
                purchase_order: 'Orders',
                restaurant: 'Restaurants',
                restaurant_list: 'Restaurant List',
                restaurant_new: 'New Restaurant',
                routes: 'Routes and Itineraries',
                routes_list: 'Route List',
                routes_new: 'New Route',
                store_parameters: 'Parameters',
                store_shipping: 'Shipping',
                taxe_list: 'Tax List',
                testemonies: 'Testimonials',
                testemonies_list: 'Testimonial List',
                testemony_new: 'Insert Testimonial',
                webuser: 'Users',
                webuser_list: 'User List',
                webuser_new: 'Insert User',
                client: 'Client',
                company: 'Company',
                client_list: 'Client List',
                client_new: 'Insert Client',
                empresa: 'Company',
                empresa_list: 'Company List',
                empresa_new: 'Insert Company',
                empresa01: 'Company01',
                empresa01_list: 'Company01 List',
                empresa01_new: 'Insert Company01',
                empresa02: 'Company02',
                empresa02_list: 'Company02 List',
                empresa02_new: 'Insert Company02',
                entidade02: 'Entity02',
                entidade02_list: 'Entity02 List',
                entidade02_new: 'Insert Entity02',
                tarefa: 'Tasks',
                tarefa_list: 'Task List',
                tarefa_new: 'Insert Task',
                projetos: 'Projects',
                projetos_list: 'Project List',
                projetos_new: 'Insert Project',
                suporte: 'Support',
                suporte_list: 'Ticket List',
                suporte_new: 'Insert Ticket',
                entidade: 'Entities',
                entidade_list: 'Entity List',
                entidade_new: 'Insert Entity',
                zone_list: 'Zone List',
                colaborador: 'Staff',
                colaborador_list: 'Staff List',
                colaborador_new: 'Insert Staff',

                license: 'Licença',

        },
        'es': {
                config: 'Configuración',
                entidade_interna: 'Entidad Interna',
                externa_entidade_list: 'Lista de entidades externas',
                entidade_externa: 'Entidad Externa',
                accommodation: 'Alojamientos',
                accommodation_list: 'Lista de alojamientos',
                accommodation_new: 'Nuevo alojamiento',
                activities: 'Actividades',
                activity_list: 'Lista de actividades',
                activity_new: 'Insertar actividad',
                animations: 'Animaciones',
                animation_list: 'Lista de animaciones',
                animation_new: 'Insertar animación',
                articles: 'Noticias',
                articles_list: 'Lista de noticias',
                article_new: 'Nuevo artículo',
                attributes: 'Atributos',
                attributes_list: 'Lista de atributos',
                attribute_new: 'Nuevo atributo',
                attribute_values: 'Valores',
                attribute_values_list: 'Lista de valores',
                attribute_value_new: 'Nuevo valor',
                banners: 'Banners',
                banners_list: 'Lista de banners',
                banner_new: 'Nuevo banner',
                brands: 'Marcas',
                brands_list: 'Lista de marcas',
                brand_new: 'Nueva marca',
                agenda: 'Agenda',
                evento: 'Evento',
                calendar: 'Calendario',
                carrier_list: 'Lista de transportistas',
                categories: 'Categorías',
                categories_list: 'Lista de categorías',
                category_new: 'Insertar categoría',
                choose_option: 'Elegir',
                content: 'Contenido',
                content_list: 'Lista de contenidos',
                content_new: 'Nuevo contenido',
                contest: 'Concurso',
                contest_list: 'Lista de concursantes',
                contest_new: 'Nuevo concursante',
                country_list: 'Lista de países',
                estancia: 'Resort',
                estancia_aulas: 'Reserva de clases',
                estancia_aulas_list: 'Lista de clases',
                estancia_aulas_new: 'Insertar clase',
                estancia_aulas_add: 'Agregar clase',
                estancia_aulas_info: 'Clases',
                estancia_aulas_info_list: 'Lista de clases',
                estancia_aulas_info_new: 'Insertar clase',
                estancia_aulas_info_add: 'Agregar clase',
                estancia_aulas_cliente: 'Programar clase',
                estancia_config: 'Gestión de pistas',
                estancia_meios: 'Medios mecánicos',
                estancia_meios_list: 'Lista de medios mecánicos',
                estancia_meio_new: 'Insertar medio',
                estancia_meio_add: 'Agregar medio',
                estancia_pistas: 'Pistas',
                estancia_pistas_list: 'Lista de pistas',
                estancia_pista_new: 'Insertar pista',
                estancia_pista_add: 'Agregar pista',
                estancia_forfaits: 'Pases de esquí',
                estancia_forfaits_list: 'Lista de pases',
                estancia_forfait_new: 'Insertar pase',
                estancia_forfait_add: 'Agregar pase',
                estancia_equipamentos: 'Equipamiento',
                estancia_equipamentos_list: 'Lista de equipos',
                estancia_equipamento_new: 'Insertar equipo',
                estancia_equipamento_add: 'Agregar equipo',
                estancia_vouchers: 'Vales',
                estancia_vouchers_list: 'Lista de vales',
                estancia_voucher_new: 'Insertar vale',
                estancia_voucher_add: 'Agregar vale',
                estancia_packs: 'Paquetes',
                estancia_packs_list: 'Lista de programas',
                estancia_pack_new: 'Insertar paquete',
                estancia_pack_add: 'Agregar paquete',
                estancia_activities: 'Actividades',
                estancia_activities_list: 'Lista de actividades',
                estancia_activities_new: 'Insertar actividad',
                estancia_activities_add: 'Agregar actividad',
                estancia_zonas: 'Zonas',
                estancia_zonas_list: 'Lista de zonas',
                estancia_zona_new: 'Insertar zona',
                estancia_zona_add: 'Agregar zona',
                estancia_instrutores: 'Instructores',
                estancia_colaboradores: 'Personal',
                estancia_parametros: 'Parámetros',
                estancia_produtos: 'Productos',
                goldenrock: 'Golden Rock',
                goldenrock_espaco: 'Espacio',
                goldenrock_category: 'Categoría',
                goldenrock_servico: 'Servicio',
                goldenrock_terapeuta: 'Terapeuta',
                goldenrock_professor: 'Profesor',
                goldenrock_horario: 'Horario',
                goldenrock_wellness: 'Bienestar',
                goldenrock_wellness_stock: 'Inventario bienestar',
                goldenrock_spa: 'SPA',
                goldenrock_spa_stock: 'Inventario SPA',
                goldenrock_piscinas: 'Piscinas',
                goldenrock_piscinas_stock: 'Inventario piscinas',
                goldenrock_ginasio: 'Gimnasio',
                goldenrock_ginasio_stock: 'Inventario gimnasio',
                goldenrock_personaltrainer: 'Entrenador personal',
                features: 'Características',
                features_list: 'Lista de características',
                feature_new: 'Nueva característica',
                feature_values: 'Valores',
                feature_values_list: 'Lista de valores',
                feature_value_new: 'Nuevo valor',
                galleries: 'Galerías',
                galleries_list: 'Lista de galerías',
                gallery_new: 'Insertar galería',
                intranet: 'Intranet',
                intranet_department: 'Departamento',
                intranet_groups: 'Grupos',
                intranet_quality: 'Calidad',

                intranet_quality_document: 'Gestão Documental',
                intranet_quality_document_obsolete: 'Documentos Obsoletos',
                intranet_quality_document_deleted: 'Documentos Eliminados',
                intranet_quality_document_type: 'Tipo de documento',
                intranet_quality_retention_type: 'Tiempo de retención',
                intranet_quality_storage_type: 'Tipo de almacenamiento',
                intranet_quality_occurrence: 'Gestão de Ocorrência',
                intranet_quality_occurrence_type: 'Tipo de Ocorrência',
                intranet_quality_occurrence_origin: 'Origem da Ocorrência',
                intranet_quality_occurrence_state: 'Estado da Ocorrência',
                intranet_quality_strategy: 'Planeamento Estratégico',
                intranet_quality_strategybetsrisks: 'Gestão de Apostas e Riscos',
                intranet_quality_monitoring_indicators: 'Gestão de Indicadores',
                intranet_quality_formation: 'Gestão de Formações',
                intranet_quality_formation_classification_type: 'Tipos de Avaliação de Formações',
                intranet_quality_formation_state_type: 'Tipos de Estados de Formações',
                intranet_quality_supplier_evaluation: 'Avaliação de Fornecedores',
                intranet_quality_supplier_evaluation_criterion: 'Critérios de Avaliação',
                intranet_quality_supplier_type: 'Avaliação de Fornecedores',
                intranet_quality_supply_quality_type: 'Avaliação de Fornecimento',
                intranet_quality_supply_type: 'Tipo de Fornecimento',
                intranet_maintenance: 'Manutenção',
                intranet_maintenance_active: 'Ativo',
                intranet_maintenance_repair: 'Reparação',
                intranet_maintenance_active_type: 'Tipo de Ativo',
                intranet_maintenance_active_state: 'Tipo de Estado',
                intranet_maintenance_repair_type: 'Tipo de Reparação',
                intranet_maintenance_energy_type: 'Tipo de Energia',
                intranet_config: 'Configuración',
                menus: 'Menús',
                menus_list: 'Lista de menús',
                menu_new: 'Insertar menú',
                my_data: 'Mis datos',
                painel_principal: 'Panel principal',
                normas_submissao: 'Normas de envío',
                evento: 'Evento',
                lista_eventos: 'Lista de eventos',
                inserir_evento: 'Insertar evento',
                events: 'Eventos',
                event_list: 'Lista de eventos',
                event_new: 'Insertar evento',
                call_for_papers: 'Llamado a trabajos',
                lista_cfp: 'Lista CFP',
                inserir_cfp: 'Insertar CFP',
                perfis: 'Perfiles',
                lista_perfis_app: 'Perfiles de usuario',
                lista_perfis_empresa: 'Tipos de entidad',
                lista_entidade_funcoes: 'Funciones',
                lista_entidade_setores: 'Sectores',
                lista_entidade_dimensoes: 'Dimensiones',
                lista_entidade_relacoes: 'Relaciones',
                inserir_perfil: 'Nuevo perfil',
                novo: 'Nuevo',
                autor: 'Autor',
                lista_autores: 'Lista de autores',
                revisor: 'Revisor',
                lista_revisores: 'Lista de revisores',
                editor: 'Editor',
                lista_editores: 'Lista de editores',
                artigo: 'Artículo',
                novo_artigo: 'Agregar artículo',
                lista_artigos: 'Lista de artículos',
                conteudo_site: 'Contenido del sitio',
                conteudo: 'Contenido',
                corporate: 'Corporativo',
                novo_conteudo: 'Nuevo contenido',
                difusao_cientifica: 'Difusión científica',
                revista: 'Revista',
                conferencia: 'Conferencia',
                nova_difusao: 'Nueva difusión',
                termos: 'Términos',
                termos_condicoes: 'Términos y condiciones',
                separador_intranet: 'INTRANET',
                separador_outros: 'OTROS',
                separador_quality: 'CALIDAD',
                separador_maintenance: 'MANUTENÇÃO E ENERGIA',
                store: 'Tienda online',
                store_products: 'Productos',
                store_products_list: 'Lista de productos',
                store_product_new: 'Insertar producto',
                store_product_add: 'Agregar producto',
                press: 'Prensa',
                press_list: 'Lista de prensa',
                press_new: 'Nuevo artículo',
                projects: 'Proyectos',
                project_areas: 'Áreas temáticas',
                project_areas_list: 'Lista de áreas temáticas',
                project_area_new: 'Insertar área',
                project_area_add: 'Agregar área',
                project_domains: 'Dominios',
                project_domains_list: 'Lista de dominios',
                project_domain_new: 'Insertar dominio',
                project_domain_add: 'Agregar dominio',
                project_funds: 'Fondos',
                project_funds_list: 'Lista de fondos',
                project_fund_new: 'Insertar fondo',
                project_fund_add: 'Agregar fondo',
                project_parameters: 'Parámetros',
                project_programs: 'Paquetes',
                project_programs_list: 'Lista de paquetes',
                project_program_new: 'Insertar paquete',
                project_program_add: 'Agregar paquete',
                project_scopes: 'Alcance territorial',
                project_scopes_list: 'Lista de alcances',
                project_scope_new: 'Insertar alcance',
                project_scope_add: 'Agregar alcance',
                politica_privacidade: 'Política de privacidad',
                purchase_order: 'Pedidos',
                restaurant: 'Restaurantes',
                restaurant_list: 'Lista de restaurantes',
                restaurant_new: 'Nuevo restaurante',
                routes: 'Rutas e itinerarios',
                routes_list: 'Lista de rutas',
                routes_new: 'Nueva ruta',
                store_parameters: 'Parámetros',
                store_shipping: 'Envío',
                taxe_list: 'Lista de impuestos',
                testemonies: 'Testimonios',
                testemonies_list: 'Lista de testimonios',
                testemony_new: 'Insertar testimonio',
                webuser: 'Usuarios',
                webuser_list: 'Lista de usuarios',
                webuser_new: 'Insertar usuario',
                client: 'Cliente',
                company: 'Empresa',
                client_list: 'Lista de clientes',
                client_new: 'Insertar cliente',
                empresa: 'Empresa',
                empresa_list: 'Lista de empresas',
                empresa_new: 'Insertar empresa',
                empresa01: 'Empresa01',
                empresa01_list: 'Lista Empresa01',
                empresa01_new: 'Insertar Empresa01',
                empresa02: 'Empresa02',
                empresa02_list: 'Lista Empresa02',
                empresa02_new: 'Insertar Empresa02',
                entidade02: 'Entidad02',
                entidade02_list: 'Lista Entidad02',
                entidade02_new: 'Insertar Entidad02',
                tarefa: 'Tareas',
                tarefa_list: 'Lista de tareas',
                tarefa_new: 'Insertar tarea',
                projetos: 'Proyectos',
                projetos_list: 'Lista de proyectos',
                projetos_new: 'Insertar proyecto',
                suporte: 'Soporte',
                suporte_list: 'Lista de tickets',
                suporte_new: 'Insertar ticket',
                entidade: 'Entidades',
                entidade_list: 'Lista de entidades',
                entidade_new: 'Insertar entidad',
                zone_list: 'Lista de zonas',
                colaborador: 'Personal',
                colaborador_list: 'Lista de personal',
                colaborador_new: 'Insertar personal',
                externa_entidade_list: 'Lista de Entidades Externas',

                license: 'Licença',

        },
        'fr': {
                config: 'Configuration',
                entidade_interna: 'Entité Interne',
                externa_entidade_list: 'Liste d’entités externes',
                entidade_externa: 'Entité Externe',
                accommodation: 'Hébergements',
                accommodation_list: 'Liste des hébergements',
                accommodation_new: 'Nouvel Hébergement',
                activities: 'Activités',
                activity_list: 'Liste des activités',
                activity_new: 'Insérer Activité',
                animations: 'Animations',
                animation_list: 'Liste des animations',
                animation_new: 'Insérer Animation',
                articles: 'Actualités',
                articles_list: 'Liste des actualités',
                article_new: 'Nouvel Article',
                attributes: 'Attributs',
                attributes_list: 'Liste des attributs',
                attribute_new: 'Nouvel Attribut',
                attribute_values: 'Valeurs',
                attribute_values_list: 'Liste des valeurs',
                attribute_value_new: 'Nouvelle Valeur',
                banners: 'Bannières',
                banners_list: 'Liste des bannières',
                banner_new: 'Nouvelle Bannière',
                brands: 'Marques',
                brands_list: 'Liste des marques',
                brand_new: 'Nouvelle Marque',
                agenda: 'Agenda',
                evento: 'Événement',
                calendar: 'Calendrier',
                carrier_list: 'Liste des transporteurs',
                categories: 'Catégories',
                categories_list: 'Liste des catégories',
                category_new: 'Insérer Catégorie',
                choose_option: 'Choisir',
                content: 'Contenu',
                content_list: 'Liste de contenus',
                content_new: 'Nouveau contenu',
                contest: 'Concours',
                contest_list: 'Liste des participants',
                contest_new: 'Nouveau participant',
                country_list: 'Liste des pays',
                estancia: 'Station',
                estancia_aulas: 'Réservation de cours',
                estancia_aulas_list: 'Liste des cours',
                estancia_aulas_new: 'Insérer un cours',
                estancia_aulas_add: 'Ajouter un cours',
                estancia_aulas_info: 'Cours',
                estancia_aulas_info_list: 'Liste des cours',
                estancia_aulas_info_new: 'Insérer un cours',
                estancia_aulas_info_add: 'Ajouter un cours',
                estancia_aulas_cliente: 'Planifier un cours',
                estancia_config: 'Gestion des pistes',
                estancia_meios: 'Remontées mécaniques',
                estancia_meios_list: 'Liste des remontées mécaniques',
                estancia_meio_new: 'Insérer un moyen',
                estancia_meio_add: 'Ajouter un moyen',
                estancia_pistas: 'Pistes',
                estancia_pistas_list: 'Liste des pistes',
                estancia_pista_new: 'Insérer une piste',
                estancia_pista_add: 'Ajouter une piste',
                estancia_forfaits: 'Forfaits de ski',
                estancia_forfaits_list: 'Liste des forfaits',
                estancia_forfait_new: 'Insérer un forfait',
                estancia_forfait_add: 'Ajouter un forfait',
                estancia_equipamentos: 'Équipements',
                estancia_equipamentos_list: 'Liste des équipements',
                estancia_equipamento_new: 'Insérer un équipement',
                estancia_equipamento_add: 'Ajouter un équipement',
                estancia_vouchers: 'Bons',
                estancia_vouchers_list: 'Liste des bons',
                estancia_voucher_new: 'Insérer un bon',
                estancia_voucher_add: 'Ajouter un bon',
                estancia_packs: 'Forfaits',
                estancia_packs_list: 'Liste des forfaits',
                estancia_pack_new: 'Insérer un forfait',
                estancia_pack_add: 'Ajouter un forfait',
                estancia_activities: 'Activités',
                estancia_activities_list: 'Liste des activités',
                estancia_activities_new: 'Insérer une activité',
                estancia_activities_add: 'Ajouter une activité',
                estancia_zonas: 'Zones',
                estancia_zonas_list: 'Liste des zones',
                estancia_zona_new: 'Insérer une zone',
                estancia_zona_add: 'Ajouter une zone',
                estancia_instrutores: 'Moniteurs',
                estancia_colaboradores: 'Personnel',
                estancia_parametros: 'Paramètres',
                estancia_produtos: 'Produits',
                goldenrock: 'Golden Rock',
                goldenrock_espaco: 'Espace',
                goldenrock_category: 'Catégorie',
                goldenrock_servico: 'Service',
                goldenrock_terapeuta: 'Thérapeute',
                goldenrock_professor: 'Professeur',
                goldenrock_horario: 'Horaire',
                goldenrock_wellness: 'Bien-être',
                goldenrock_wellness_stock: 'Stock bien-être',
                goldenrock_spa: 'SPA',
                goldenrock_spa_stock: 'Stock SPA',
                goldenrock_piscinas: 'Piscines',
                goldenrock_piscinas_stock: 'Stock piscines',
                goldenrock_ginasio: 'Salle de sport',
                goldenrock_ginasio_stock: 'Stock salle de sport',
                goldenrock_personaltrainer: 'Coach personnel',
                features: 'Caractéristiques',
                features_list: 'Liste des caractéristiques',
                feature_new: 'Nouvelle caractéristique',
                feature_values: 'Valeurs',
                feature_values_list: 'Liste des valeurs',
                feature_value_new: 'Nouvelle valeur',
                galleries: 'Galeries',
                galleries_list: 'Liste des galeries',
                gallery_new: 'Insérer une galerie',
                intranet: 'Intranet',
                intranet_department: 'Département',
                intranet_groups: 'Groupes',
                intranet_quality: 'Qualité',
                intranet_quality_document: 'Gestão Documental',
                intranet_quality_document_obsolete: 'Documentos Obsoletos',
                intranet_quality_document_deleted: 'Documentos Eliminados',
                intranet_quality_document_type: 'Type de document',
                intranet_quality_retention_type: 'Durée de conservation',
                intranet_quality_storage_type: 'Type de stockage',
                intranet_quality_occurrence: 'Gestão de Ocorrência',
                intranet_quality_occurrence_type: 'Tipo de Ocorrência',
                intranet_quality_occurrence_origin: 'Origem da Ocorrência',
                intranet_quality_occurrence_state: 'Estado da Ocorrência',
                intranet_quality_strategy: 'Planeamento Estratégico',
                intranet_quality_strategybetsrisks: 'Gestão de Apostas e Riscos',
                intranet_quality_monitoring_indicators: 'Gestão de Indicadores',
                intranet_quality_formation: 'Gestão de Formações',
                intranet_quality_formation_classification_type: 'Tipos de Avaliação de Formações',
                intranet_quality_formation_state_type: 'Tipos de Estados de Formações',
                intranet_quality_supplier_evaluation: 'Avaliação de Fornecedores',
                intranet_quality_supplier_evaluation_criterion: 'Critérios de Avaliação',
                intranet_quality_supplier_type: 'Avaliação de Fornecedores',
                intranet_quality_supply_quality_type: 'Avaliação de Fornecimento',
                intranet_quality_supply_type: 'Tipo de Fornecimento',

                intranet_maintenance: 'Manutenção',
                intranet_maintenance_active: 'Ativo',
                intranet_maintenance_repair: 'Reparação',
                intranet_maintenance_active_type: 'Tipo de Ativo',
                intranet_maintenance_active_state: 'Tipo de Estado',
                intranet_maintenance_repair_type: 'Tipo de Reparação',
                intranet_maintenance_energy_type: 'Tipo de Energia',
                intranet_config: 'Configuration',
                menus: 'Menus',
                menus_list: 'Liste des menus',
                menu_new: 'Insérer un menu',
                my_data: 'Mes données',
                painel_principal: 'Tableau de bord',
                normas_submissao: 'Normes de soumission',
                evento: 'Événement',
                lista_eventos: 'Liste des événements',
                inserir_evento: 'Insérer un événement',
                events: 'Événements',
                event_list: 'Liste des événements',
                event_new: 'Insérer un événement',
                call_for_papers: 'Appel à contributions',
                lista_cfp: 'Liste des CFP',
                inserir_cfp: 'Insérer un CFP',
                perfis: 'Profils',
                lista_perfis_app: 'Profils utilisateur',
                lista_perfis_empresa: 'Types d’entité',
                lista_entidade_funcoes: 'Fonctions',
                lista_entidade_setores: 'Secteurs',
                lista_entidade_dimensoes: 'Dimensions',
                lista_entidade_relacoes: 'Relations',
                inserir_perfil: 'Nouveau profil',
                novo: 'Nouveau',
                autor: 'Auteur',
                lista_autores: 'Liste des auteurs',
                revisor: 'Réviseur',
                lista_revisores: 'Liste des réviseurs',
                editor: 'Éditeur',
                lista_editores: 'Liste des éditeurs',
                artigo: 'Article',
                novo_artigo: 'Ajouter un article',
                lista_artigos: 'Liste des articles',
                conteudo_site: 'Contenu du site',
                conteudo: 'Contenu',
                corporate: 'Entreprise',
                novo_conteudo: 'Nouveau contenu',
                difusao_cientifica: 'Diffusion scientifique',
                revista: 'Revue',
                conferencia: 'Conférence',
                nova_difusao: 'Nouvelle diffusion',
                termos: 'Termes',
                termos_condicoes: 'Termes et conditions',
                separador_intranet: 'INTRANET',
                separador_outros: 'AUTRES',
                separador_quality: 'QUALITÉ',
                separador_maintenance: 'MANUTENÇÃO E ENERGIA',
                store: 'Boutique en ligne',
                store_products: 'Produits',
                store_products_list: 'Liste des produits',
                store_product_new: 'Insérer un produit',
                store_product_add: 'Ajouter un produit',
                press: 'Presse',
                press_list: 'Liste des articles de presse',
                press_new: 'Nouvel article',
                projects: 'Projets',
                project_areas: 'Domaines thématiques',
                project_areas_list: 'Liste des domaines',
                project_area_new: 'Insérer un domaine',
                project_area_add: 'Ajouter un domaine',
                project_domains: 'Domaines',
                project_domains_list: 'Liste des domaines',
                project_domain_new: 'Insérer un domaine',
                project_domain_add: 'Ajouter un domaine',
                project_funds: 'Financements',
                project_funds_list: 'Liste des financements',
                project_fund_new: 'Insérer un financement',
                project_fund_add: 'Ajouter un financement',
                project_parameters: 'Paramètres',
                project_programs: 'Programmes',
                project_programs_list: 'Liste des programmes',
                project_program_new: 'Insérer un programme',
                project_program_add: 'Ajouter un programme',
                project_scopes: 'Portée géographique',
                project_scopes_list: 'Liste des portées',
                project_scope_new: 'Insérer une portée',
                project_scope_add: 'Ajouter une portée',
                politica_privacidade: 'Politique de confidentialité',
                purchase_order: 'Commandes',
                restaurant: 'Restaurants',
                restaurant_list: 'Liste des restaurants',
                restaurant_new: 'Nouveau restaurant',
                routes: 'Itinéraires',
                routes_list: 'Liste des itinéraires',
                routes_new: 'Nouvel itinéraire',
                store_parameters: 'Paramètres',
                store_shipping: 'Expédition',
                taxe_list: 'Liste des taxes',
                testemonies: 'Témoignages',
                testemonies_list: 'Liste des témoignages',
                testemony_new: 'Insérer un témoignage',
                webuser: 'Utilisateurs',
                webuser_list: 'Liste des utilisateurs',
                webuser_new: 'Insérer un utilisateur',
                client: 'Client',
                company: 'Entreprise',
                client_list: 'Liste des clients',
                client_new: 'Insérer un client',
                empresa: 'Entreprise',
                empresa_list: 'Liste des entreprises',
                empresa_new: 'Insérer une entreprise',
                empresa01: 'Entreprise01',
                empresa01_list: 'Liste Entreprise01',
                empresa01_new: 'Insérer Entreprise01',
                empresa02: 'Entreprise02',
                empresa02_list: 'Liste Entreprise02',
                empresa02_new: 'Insérer Entreprise02',
                entidade02: 'Entité02',
                entidade02_list: 'Liste Entité02',
                entidade02_new: 'Insérer Entité02',
                tarefa: 'Tâches',
                tarefa_list: 'Liste des tâches',
                tarefa_new: 'Insérer une tâche',
                projetos: 'Projets',
                projetos_list: 'Liste des projets',
                projetos_new: 'Insérer un projet',
                suporte: 'Support',
                suporte_list: 'Liste des tickets',
                suporte_new: 'Insérer un ticket',
                entidade: 'Entités',
                entidade_list: 'Liste des entités',
                entidade_new: 'Insérer une entité',
                zone_list: 'Liste des zones',
                colaborador: 'Personnel',
                colaborador_list: 'Liste du personnel',
                colaborador_new: 'Insérer un membre du personnel',
                externa_entidade_list: 'Liste des entités externes',

                license: 'Licença',


        }
}


module.exports = {
        language
};
